<template>
  <div class="home">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="page-header">
            <router-link
              :to="{ path: 'new/wo', append: true }"
              class="btn btn-info btn-lg float-right my-1 mx-1">
              <i class="fa fa-wrench fa-fw mr-2"></i> Issue Work Order
            </router-link>
            <router-link
              :to="{ path: 'new/qr', append: true }"
              class="btn btn-primary btn-lg float-right my-1 mx-1">
              <i class="fa fa-quote-right fa-fw mr-2"></i> Request Report Quote
            </router-link>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-5">
          <div v-if="$route.meta.showSearch" @click="toggleSearch()" v-show="searchHidden">
            <p class="form-control text-muted fake-input interactive-cursor">
              Search...
              <span class="fa fa-search float-right"></span>
            </p>
          </div>
          <div v-show="!searchHidden">
            <vue-form
              ref="form"
              :sections="quotesSearchForm.fields"
              :options="{
                submit: 'Search',
                submitting: 'Searching...',
                permalink: $route.meta.quoteType,
                method: 'search'
              }">
              <span slot="title">
                <i class="fa fa-search fa-fw"></i> Search {{ quotes.searchForm.plural }}
                <span class="fa fa-times float-right fa-lg text-danger interactive-cursor" @click="toggleSearch()"></span>
              </span>
              <div class="form-group" slot="actions">
                <div class="col-sm-8 col-sm-offset-4">
                  <button class="btn btn-success" type="button" @click="refresh()">Search</button>
                </div>
              </div>
            </vue-form>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <paging-input ref="paging"
            @change="changePage"
            :options="{
              current: (quotes.offset + parseInt(quotes.limit)) / parseInt(quotes.limit),
              totalResults: quotes.count,
              limit: parseInt(quotes.limit)
            }"
            v-if="quotes.count">
          </paging-input>
          <responsive-table 
            @orderColumn="sort($event)" 
            :hideTitle="true" 
            :table="{ columns: quotes.columns }" 
            :default-sort-column="sortColumn" 
            :default-sort="sortDirection">
            <template slot="rows">
              <template v-for="(row, i) in quotes.rows">
                <component
                  :is="parseType($route.meta.quoteType) + '-row'"
                  :object="row"
                  :index="i"
                  :key="i">
                </component>
              </template>
            </template>
          </responsive-table>
          <paging-input ref="paging"
            @change="changePage"
            :options="{
              current: (quotes.offset + parseInt(quotes.limit)) / parseInt(quotes.limit),
              totalResults: quotes.count,
              limit: parseInt(quotes.limit)
            }"
            v-if="quotes.count">
          </paging-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'
  import {
    LOAD_QUOTES
  } from '@/vuex/types'
  import VueForm from '@/components/Form.vue'
  import ResponsiveTable from '@/components/ui/ResponsiveTable.vue'
  import PagingInput from '@/components/inputs/PagingInput.vue'
  // ROWS ------- //
  import PropertyReportQuoteRequestRow from '@/components/rows/PropertyReportQuoteRequest.vue'

  export default {
    name: 'ClientQuotes',
    components: {
      PagingInput,
      PropertyReportQuoteRequestRow,
      ResponsiveTable,
      VueForm
    },
    data () {
      return {
        sortColumn: false,
        sortDirection: false,
        searchForm: [],
        searchOffset: 0,
        searchLimit: 25,
        searchHidden: true,
        newSearch: true,
        noResults: 'Your search returned 0 results',
        pagingOptions: {
          totalResults: 10,
          limit: 10,
          current: 1
        },
        newPermalink: false
      }
    },
    computed: {
      ...mapGetters([
        'quotes',
        'quotesSearchForm'
      ])
    },
    mounted () {
      this.createNewSearch()
    },
    watch: {
      $route () {
        this.createNewSearch()
      }
    },
    methods: {
      sort (column) {
        this.sortColumn = column.name
        this.sortDirection = column.sortDirection
        this.search()
      },
      async createNewSearch () {
        this.searchOffset = 0
        await this.$store.dispatch(LOAD_QUOTES, {
          dataName: this.$route.meta.quoteType,
          searchForm: false,
          offset: this.searchOffset,
          limit: this.quotes.limit,
          newSearch: true,
          sortColumn: this.sortColumn,
          sortDirection: this.sortDirection
        })
      },
      async refresh () {
        this.searchOffset = 0
        await this.search()
      },
      async search () {
        await this.$refs.form.validateForm()
        if (this.$refs.form.validForm) {
          let searchForm = this.quotesSearchForm
          let limit = searchForm.fields.splice(-1, 1)
          await this.$store.dispatch(LOAD_QUOTES, {
            dataName: this.$route.meta.quoteType,
            searchForm,
            offset: this.searchOffset,
            limit: limit[0].value,
            newSearch: this.newSearch,
            sortColumn: this.sortColumn,
            sortDirection: this.sortDirection
          })
        }
      },
      async toggleSearch () {
        this.searchHidden = !this.searchHidden
        if (!this.searchHidden) {
          await this.$nextTick()
          this.$refs.form.$el.querySelectorAll('input[type=text]')[0].focus()
        }
      },
      async changePage (page) {
        this.searchOffset = (page - 1) * this.quotes.limit
        await this.search()
      },
      parseType (type) {
        switch (type) {
          case 'propertyReporting':
            return 'property-report-quote-request'
          default:
            return type
        }
      }
    }
  }

</script>


// WEBPACK FOOTER //
// src/components/client/Quotes.vue